package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

/**
 * EmojiRating component that displays 5 emoji options with selection state
 * Matches the design from the feedback section image
 */
@Composable
fun EmojiRating(
    selectedRating: Int?,
    onRatingSelected: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    val emojis = listOf("😔", "😕", "😐", "😊", "🥰")
    val labels = listOf("Deloc", "Puțin", "Așa și așa", "Da", "Super")

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        emojis.forEachIndexed { index, emoji ->
            val rating = index + 1
            val isSelected = selectedRating == rating
            val isHovered = remember { mutableStateOf(false) }

            Column(
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .padding(8.px)
                    .borderRadius(12.px)
                    .backgroundColor(
                        if (isSelected) Color("#10b981")
                        else if (isHovered.value) Color("rgba(16, 185, 129, 0.1)")
                        else Color("rgba(255, 255, 255, 0.8)")
                    )
                    .border(
                        if (!isSelected && !isHovered.value) 1.px else 0.px,
                        LineStyle.Solid,
                        Color("rgba(0, 0, 0, 0.1)")
                    )
                    .onClick { onRatingSelected(rating) }
                    .onMouseEnter { isHovered.value = true }
                    .onMouseLeave { isHovered.value = false },
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                // Emoji
                SpanText(
                    text = emoji,
                    modifier = Modifier
                        .fontSize(28.px)
                        .margin(bottom = if (isSelected) 4.px else 0.px)
                )

                // Label (shown on selection)
                if (isSelected) {
                    SpanText(
                        text = labels[index],
                        modifier = Modifier
                            .fontSize(12.px)
                            .fontWeight(600)
                            .color(AppTheme.colors.surface)
                            .textAlign(TextAlign.Center)
                    )
                }
            }
        }
    }
}
